import { useCallback, useRef } from 'react';
import { actions } from '@/store';
export function useSidebarResize(snap, setIsResizing) {
  const isResizingRef = useRef(false);
  const handleSidebarResizeMouseDown = useCallback(e => {
    // Prevent default to stop scrolling/selection
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
    isResizingRef.current = true;

    // Get initial X coordinate
    let startX;
    if ('touches' in e) {
      startX = e.touches[0].clientX;
    } else {
      startX = e.clientX;
    }
    const startWidth = snap.uiSettings.sidebarWidth;
    function handleEnd() {
      setIsResizing(false);
      isResizingRef.current = false;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleEnd);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleEnd);
      document.body.style.cursor = '';
    }
    function handleMove(clientX) {
      const delta = clientX - startX;
      const rawWidth = startWidth + delta;
      if (rawWidth < 150) {
        actions.setUIVisibility('showSidebar', false);
        actions.setSidebarWidth(250);
        handleEnd();
        return;
      }
      const newWidth = Math.min(Math.max(200, rawWidth), 600);
      actions.setSidebarWidth(newWidth);
    }
    function handleMouseMove(ev) {
      handleMove(ev.clientX);
    }
    function handleTouchMove(ev) {
      handleMove(ev.touches[0].clientX);
    }
    document.body.style.cursor = 'col-resize';
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleEnd);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleEnd);
  }, [snap.uiSettings.sidebarWidth, setIsResizing]);
  const handleSidebarResizeKeyDown = useCallback(e => {
    const step = e.shiftKey ? 50 : 10;
    if (e.key === 'ArrowLeft') {
      const rawWidth = snap.uiSettings.sidebarWidth - step;
      if (rawWidth < 150) {
        actions.setUIVisibility('showSidebar', false);
        actions.setSidebarWidth(250);
        return;
      }
      const newWidth = Math.max(200, rawWidth);
      actions.setSidebarWidth(newWidth);
    } else if (e.key === 'ArrowRight') {
      const newWidth = Math.min(600, snap.uiSettings.sidebarWidth + step);
      actions.setSidebarWidth(newWidth);
    }
  }, [snap.uiSettings.sidebarWidth]);
  return {
    handleSidebarResizeMouseDown,
    handleSidebarResizeKeyDown,
    isResizingRef
  };
}
